import DOMPurify from 'dompurify'

const HTML_TAG_PATTERN = /<(br|p|div|b|i|strong|em|ul|ol|li|span)[\s/>]/i

const SANITIZE_OPTIONS: DOMPurify.Config = {
  ALLOWED_TAGS: ['b', 'strong', 'i', 'em', 'u', 'br', 'p', 'ul', 'ol', 'li', 'a'],
  ALLOWED_ATTR: ['href', 'target', 'rel']
}

export const looksLikeHtml = (value: string): boolean => HTML_TAG_PATTERN.test(value)

export const sanitizeDescriptionHtml = (html: string): string =>
  DOMPurify.sanitize(html, SANITIZE_OPTIONS)

export const plainTextToDescriptionHtml = (text: string): string => {
  const escaped = text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  return escaped.replace(/\r\n/g, '\n').split('\n').map(line => `<p>${line || '<br>'}</p>`).join('')
}

export const normalizeDescriptionHtml = (value: string | null | undefined): string => {
  if (!value?.trim()) {
    return ''
  }

  if (looksLikeHtml(value)) {
    return sanitizeDescriptionHtml(value)
  }

  return plainTextToDescriptionHtml(value)
}

export const isEmptyDescriptionHtml = (html: string | null | undefined): boolean => {
  if (!html?.trim()) {
    return true
  }

  const text = DOMPurify.sanitize(html, {ALLOWED_TAGS: []}).replace(/\u00a0/g, ' ').trim()
  return text.length === 0
}

export const descriptionHtmlForSave = (html: string | null | undefined): string => {
  if (isEmptyDescriptionHtml(html)) {
    return ''
  }

  return sanitizeDescriptionHtml(html ?? '')
}
